export default __webpack_public_path__ + "static/media/truck-cabin.6da419e2.svg";